export default "__VITE_ASSET__325bea7f__"